<template>
  <v-row no-gutters>
    <v-col v-if="!hasBindedStyle" cols="9" class="_pr">
      <Select
        v-model="selectedSection[textType]['font']"
        placeholder="Fonte"
        :items="fontsType"
        :showBorder="true"
      />
    </v-col>

    <v-col v-if="!hasBindedStyle" cols="3">
      <TextField 
        v-model="fontSize[textType]"
        placeholder="px"
        type="number"
        :minValueForNumber="10"
        :disabled="hasBindedStyle"
        @input="updateSize($event, selectedSection[textType])"
      />                       
    </v-col>

    <v-col v-if="!hasBindedStyle" :cols="showField('alignment') ? 4 : 9" :class="['_pt _pr-', {'pr-2': !showField('alignment')}]">
      <ColorPickerV2 
        :colorSelected="selectedSection[textType]" 
        type="color" 
        title="" 
        :compact="showField('alignment')"
      />   
    </v-col>

    <v-col v-if="showField('alignment')" cols="5" class="_pt _pl-">
      <FormAlignment v-model="selectedSection[textType]" />
    </v-col>

    <v-col 
      v-if="!hasBindedStyle"
      cols="3" 
      :class="[
        '_pt', 
        {'pl-2': showField('alignment')}, 
        {'pl-0': !showField('alignment')}
      ]"
    >
      <FormBoldItalic v-model="selectedSection[textType]" /> 
    </v-col>

    <v-col v-if="showField('content')" cols="12" class="_pt vue-editor">
      <TextField v-if="textType !== 'text' && !useTextArea" v-model="selectedSection[textType]['content']"/>
      <TextArea v-else-if="textType !== 'text' && useTextArea" v-model="selectedSection[textType]['content']" height="100px" :hideDetails="true"/>
      <VueEditor
        v-else
        v-model="selectedSection[textType]['content']"
        :editorToolbar="editorToolbar"
        :editorOptions="editorSettings"
      />
    </v-col>
  </v-row>  
</template>

<script>
import { VueEditor } from "vue2-editor";
import Select from '../../../_v2/ui/Select.vue'
import TextField from '../../../_v2/ui/TextField.vue'
import TextArea from '../../../_v2/ui/TextArea.vue'
import ColorPickerV2 from '../../../_v2/ui/ColorPickerV2.vue'
import FormBoldItalic from '../../../_v2/utils/FormBoldItalic.vue'
import FormAlignment from '../../../_v2/utils/FormAlignment.vue'

export default {
  name: 'Texts',
  components: {Select, TextField, TextArea, ColorPickerV2, FormBoldItalic, VueEditor, FormAlignment},
  props: {
    selectedSection: {type: Object, required: true},
    sectionType: {type: String, required: true},
    textType: {type: String, required: true, default: 'text'}, // title, subtitle, text, observation
    hide: {type: Array, default: () => ([])}, // ['alignment', 'content'] 
    useTextArea: {type: Boolean, default: false}
  },

  computed: {
    hasBindedStyle () {
      return this.selectedSection.idLayout ? true : false
    }
  },

  data: () => ({
    fontsType: ["Inter", "Montserrat", "Roboto", "Work Sans"],
    fontSize: {
      title: '',
      subtitle: '',
      text: '',
      buttonBorderRadius: ''
    },
    editorToolbar: [
      ["bold", "italic", "underline"],
      [{ list: "ordered" }, { list: "bullet" }],
      ["link"],
      ["clean"],
    ],
    editorSettings: {}    
  }),

  mounted () {
    this.formatOnInit()
  },      

  methods: {
    formatOnInit() {
      if (this.selectedSection[this.textType] && this.selectedSection[this.textType]['font-size']) 
        this.fontSize[this.textType] = this.selectedSection[this.textType]["font-size"].split("px")[0]
    },

    updateSize(event, type, border) {
      let model = "";
      model = event + "px";
      if (border === "border") type["button-border-radius"] = model;
      else type["font-size"] = model;
    },

    showField (type) {
      return !this.hide.includes(type)
    }
  }
}
</script>

<style scoped>
  .vue-editor /deep/ .quillWrapper .ql-snow.ql-toolbar {
    background-color: #F6F7F7 !important;
    border: #EDEDF1 1px solid !important;
    border-radius: 8px !important    
  }

  .vue-editor /deep/ .ql-container {
    margin-top: 12px;
    height: 160px !important;
    background-color: #F6F7F7 !important;
    border-radius: 8px !important;
    border: #EDEDF1 1px solid !important;
  }

  .vue-editor /deep/ .ql-toolbar.ql-snow+{
    border-top: 1px !important;
  }

  .vue-editor /deep/ .ql-editor {
    font-size: 15px !important;
    color: #192B46 !important;
    min-height: 160px !important;
  }
</style>

